import React from 'react';
import { format, startOfWeek, addDays, isSameDay } from 'date-fns';
import { es } from 'date-fns/locale';

interface SidebarCitasProps {
    isOpen: boolean;
    onToggle: () => void;
}

interface CitaMock {
    id: number;
    hora: string;
    visitante: string;
    anfitrion: string;
    estado: 'pendiente' | 'en_curso' | 'finalizada';
}

const SidebarCitas: React.FC<SidebarCitasProps> = ({ isOpen, onToggle }) => {
    const [selectedDate, setSelectedDate] = React.useState(new Date());

    const citasMock: CitaMock[] = [
        { id: 1, hora: '09:00', visitante: 'Juan Pérez', anfitrion: 'Ana López', estado: 'pendiente' },
        { id: 2, hora: '10:30', visitante: 'María García', anfitrion: 'Carlos Ruiz', estado: 'en_curso' },
        { id: 3, hora: '14:00', visitante: 'Pedro Sánchez', anfitrion: 'Laura Méndez', estado: 'finalizada' },
        { id: 4, hora: '16:00', visitante: 'Lucía Fernández', anfitrion: 'Jorge Castro', estado: 'pendiente' },
    ];

    const startDate = startOfWeek(selectedDate, { weekStartsOn: 1 });
    const weekDays = Array.from({ length: 7 }).map((_, i) => addDays(startDate, i));

    const handleDateClick = (date: Date) => {
        setSelectedDate(date);
        console.log('Fecha seleccionada:', format(date, 'yyyy-MM-dd'));
    };

    return (
        <>
            {/* Botón flotante (absoluto) */}
            <button
                className="btn btn-primary rounded-end-0"
                style={{
                    position: 'absolute',
                    zIndex: 1050,
                    left: isOpen ? '275px' : '0px',
                    bottom:'5%',
                    transform: 'translateY(-50%)',
                    transition: 'left 0.3s'
                }}
                onClick={onToggle}
                title={isOpen ? "Ocultar calendario" : "Mostrar calendario"}
            >
                <i className={`bi bi-chevron-${isOpen ? 'left' : 'right'}`}></i>
            </button>

            {/* Sidebar overlay */}
            <div
                className="bg-light shadow-lg position-absolute top-0 start-0 h-100"
                style={{
                    width: '300px',
                    zIndex: 1040,
                    transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
                    transition: 'transform 0.3s ease-in-out',
                    overflowY: 'auto'
                }}
            >
                <div className="p-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="mb-0">Citas Agendadas</h6>
                        <button className="btn btn-sm btn-primary" 
                            title='Ocultar Calendario'
                            onClick={onToggle}>
                            <i className="bi bi-x-lg"></i>
                        </button>
                    </div>

                    {/* Calendario semanal */}
                    <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <button className="btn btn-sm btn-outline-primary">
                                <i className="bi bi-chevron-left"></i>
                            </button>
                            <span className="fw-bold">{format(selectedDate, 'MMMM yyyy', { locale: es })}</span>
                            <button className="btn btn-sm btn-outline-primary">
                                <i className="bi bi-chevron-right"></i>
                            </button>
                        </div>
                        <div className="d-flex justify-content-between text-center">
                            {weekDays.map((day, idx) => (
                                <div
                                    key={idx}
                                    className={`p-1 rounded-circle ${isSameDay(day, selectedDate) ? 'bg-primary text-white' : ''}`}
                                    style={{ width: '36px', cursor: 'pointer' }}
                                    onClick={() => handleDateClick(day)}
                                >
                                    <small>{format(day, 'EEEEE', { locale: es })}</small>
                                    <div className="fw-bold">{format(day, 'd')}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Lista de citas */}
                    <h6 className="mb-2">Citas de hoy</h6>
                    <div className="list-group">
                        {citasMock.map(cita => (
                            <div key={cita.id} className="list-group-item list-group-item-action p-2">
                                <div className="d-flex justify-content-between">
                                    <small className="fw-bold">{cita.hora}</small>
                                    <span className={`badge bg-${cita.estado === 'pendiente' ? 'warning' : cita.estado === 'en_curso' ? 'success' : 'secondary'}`}>
                                        {cita.estado}
                                    </span>
                                </div>
                                <div className="small">{cita.visitante}</div>
                                <small className="text-muted">Anfitrión: {cita.anfitrion}</small>
                            </div>
                        ))}
                    </div>
                    <button className="btn btn-link btn-sm w-100 mt-3">Ver todas las citas</button>
                </div>
            </div>
        </>
    );
};

export default SidebarCitas;